export function uploadPhaseMessage(status, progress, lastError) {
  if (status === "reading") return "Leyendo archivo…";
  if (status === "uploading") return `Subiendo… ${progress}%`;
  if (status === "done") return "Subida completada";
  if (status === "error") return `Error: ${lastError}`;
  return "";
}
